export default {
      id: "device_management-usage",
      viewBox: "0 0 37.41 44.67",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#device_management-usage",
      toString: function () {
        return this.url;
      }
    }